export const DEV_PANEL_TEST_IDS = {
    root: 'dev-panel',
    offers: 'dev-panel-offers',
    boot: 'dev-panel-boot',
    template: 'dev-panel-template',
    save: 'dev-panel-save',
    clear: 'dev-panel-clear',
    close: 'dev-panel-close',
    error: 'dev-panel-error',
    tabMocks: 'dev-panel-tab-mocks',
    tabFonts: 'dev-panel-tab-fonts',
    fontList: 'dev-panel-font-list',
} as const;

export const DEV_PANEL_TITLE_ID = 'dev-panel-title';
